<template>
  <div class="step-one">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      size="small"
      class="form"
      label-width="190px"
      hide-required-asterisk
    >
      <div class="title">营业证件信息</div>
      <el-form-item label="营业执照照片" prop="licenseImg">
        <el-upload
          class="uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="(file) => upload(file, 'licenseImg')"
          @click.native="handleTips('licenseImg')"
        >
          <el-image
            class="upload_img"
            v-if="form.licenseImg"
            :src="form.licenseImg"
            fit="cover"
          ></el-image>
          <div class="pl" v-else>
            <i class="el-icon-plus"></i>
            <p class="upload-tips">上传营业执照</p>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="form.companyName"
          maxlength="60"
          show-word-limit
          placeholder="请输入公司名称"
          @click.native="handleTips('companyName')"
        ></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="crediCode">
        <el-input
          v-model="form.crediCode"
          maxlength="18"
          show-word-limit
          placeholder="请输入92开头的18位阿拉伯数字或大写英文字母"
          @click.native="handleTips('crediCode')"
        ></el-input>
      </el-form-item>
      <el-form-item label="主体类型">
        <p>{{ $route.query.type == 1 ? "个体工商户" : "企业" }}</p>
      </el-form-item>
      <el-form-item label="营业期限" prop="date">
        <el-date-picker
          v-model="form.date"
          type="date"
          placeholder="请选择"
          :disabled="dateLong"
          @click.native="handleTips('date')"
        >
        </el-date-picker>
        <el-checkbox v-model="dateLong" style="margin-left: 10px"
          >长期</el-checkbox
        >
      </el-form-item>
      <el-form-item label="经营地址" prop="address">
        <el-cascader
          v-model="form.address"
          :options="citys"
          :props="{ label: 'name', value: 'name' }"
          clearable
          @click.native="handleTips('address')"
        ></el-cascader>
      </el-form-item>

      <div class="line"></div>

      <div class="title">
        {{ $route.query.type == 1 ? "经营者" : "法定代表人" }}信息
      </div>
      <el-form-item
        :label="
          $route.query.type == 1 ? '经营者身份归属地' : '法定代表人身份归属地'
        "
        prop="personAddress"
      >
        <el-select
          v-model="form.personAddress"
          placeholder="请选择"
          @click.native="handleTips('personAddress')"
        >
          <el-option label="中国大陆" value="中国大陆"> </el-option>
          <el-option label="中国香港" value="中国香港"> </el-option>
          <el-option label="中国澳门" value="中国澳门"> </el-option>
          <el-option label="中国台湾" value="中国台湾"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传方式">
        <el-radio-group
          v-model="form.uploadType"
          @click.native="handleTips('uploadType')"
        >
          <el-radio label="电脑上传">电脑上传</el-radio>
          <el-radio label="微信上传">微信上传</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="身份证照片" prop="idCardImg">
        <el-upload
          class="uploader cardUploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="(file) => upload(file, 'frontIdCard')"
          @click.native="handleTips('frontIdCard')"
        >
          <el-image
            class="upload_img"
            v-if="form.frontIdCard"
            :src="form.frontIdCard"
            fit="cover"
          ></el-image>
          <div class="pl" v-else>
            <el-image
              :src="require('@/assets/images/simulation/frontIdCard.svg')"
              fit="cover"
              style="margin-top: 10px"
            ></el-image>
            <p class="upload-tips">上传人像面</p>
          </div>
        </el-upload>
        <el-upload
          class="uploader cardUploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="(file) => upload(file, 'backIdCard')"
          @click.native="handleTips('backIdCard')"
        >
          <el-image
            class="upload_img"
            v-if="form.backIdCard"
            :src="form.backIdCard"
            fit="cover"
          ></el-image>
          <div class="pl" v-else>
            <el-image
              :src="require('@/assets/images/simulation/backIdCard.svg')"
              fit="cover"
              style="margin-top: 10px"
            ></el-image>
            <p class="upload-tips">上传国徽面</p>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item
        :label="$route.query.type == 1 ? '经营者姓名' : '法定代表人姓名'"
        prop="realName"
      >
        <el-input
          class="short"
          v-model="form.realName"
          maxlength="40"
          show-word-limit
          :placeholder="
            $route.query.type == 1
              ? '请输入营业执照上登记的经营者姓名'
              : '请输入营业执照上登记的法定代表人姓名'
          "
          @click.native="handleTips('realName')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="
          $route.query.type == 1 ? '经营者身份证号码' : '法定代表人身份证号码'
        "
        prop="idNumber"
      >
        <el-input
          class="short"
          v-model="form.idNumber"
          maxlength="18"
          show-word-limit
          :placeholder="
            $route.query.type == 1
              ? '请输入经营者姓名一致的身份证号码'
              : '请输入法定代表人姓名一致的身份证号码'
          "
          @click.native="handleTips('idNumber')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="
          $route.query.type == 1
            ? '经营者身份证有效期'
            : '法定代表人身份证有效期'
        "
        prop="idCardDate"
      >
        <el-date-picker
          v-model="form.idCardDate"
          type="date"
          placeholder="请与身份证保持一致"
          :disabled="idCardDateLong"
          @click.native="handleTips('idCardDate')"
        >
        </el-date-picker>
        <el-checkbox v-model="idCardDateLong" style="margin-left: 10px"
          >长期</el-checkbox
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import city from "@/utils/city";
import upload from "@/utils/uploadMethod";
export default {
  data() {
    var checkIdCard = (rule, value, callback) => {
      if (!this.form.frontIdCard && !this.form.backIdCard) {
        return callback(new Error("请上传身份证人像面、身份证国徽面照片"));
      } else if (!this.form.frontIdCard) {
        callback(new Error("请上传身份证人像面照片"));
      } else if (!this.form.backIdCard) {
        callback(new Error("请上传身份证国徽面照片"));
      } else {
        callback();
      }
    };
    return {
      form: {
        licenseImg: "",
        companyName: "",
        crediCode: "",
        date: "",
        address: "",
        personAddress: "",
        uploadType: "电脑上传",
        frontIdCard: "",
        backIdCard: "",
        realName: "",
        idNumber: "",
        idCardDate: "",
      },
      dateLong: false,
      idCardDateLong: false,
      rules: {
        licenseImg: {
          required: true,
          message: "请上传营业执照照片",
          trigger: "blur",
        },
        companyName: {
          required: true,
          message: "请输入公司名称",
          trigger: "blur",
        },
        crediCode: {
          required: true,
          message: "请输入统一社会信用代码",
          trigger: "blur",
        },
        date: {
          required: true,
          message: "请选择营业期限",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "请选择经营地址",
          trigger: "blur",
        },
        idCardImg: {
          validator: checkIdCard,
          trigger: "blur",
        },
        realName: {
          required: true,
          message: "请输入经营者姓名",
          trigger: "blur",
        },
        idNumber: {
          required: true,
          message: "请输入经营者身份证号码",
          trigger: "blur",
        },
        idCardDate: {
          required: true,
          message: "请选择证件有效期",
          trigger: "blur",
        },
      },
      citys: city.cityArr,
    };
  },
  watch: {
    dateLong(val) {
      if (val) {
        this.form.date = "长期";
      } else {
        this.form.date = "";
      }
    },
    idCardDateLong(val) {
      if (val) {
        this.form.idCardDate = "长期";
      } else {
        this.form.idCardDate = "";
      }
    },
  },
  methods: {
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.form[str] = fileUrl;
    },
    handleTips(formItem) {
      this.$emit("onTips", formItem);
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("onSuccess", this.form);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.step-one {
  text-align: left;
  .title {
    margin: 24px 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #12141a;
  }
  ::v-deep .form {
    .el-form-item {
      margin-bottom: 24px;
    }
    .el-form-item__content {
      width: 430px;
    }
    .uploader {
      position: relative;
      width: 120px;
      height: 120px;
      border: 1px dashed #dcdde0;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      &.cardUploader {
        display: inline-block;
        margin-right: 8px;
        width: 88px;
        height: 88px;
        .upload_img {
          width: 88px;
          height: 88px;
          display: block;
        }
      }
      &:hover {
        border-color: #3388ff;
        .pl {
          color: #3388ff;
        }
      }

      .pl {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 100%;
        color: #85878a;
        transform: translate(-50%, -50%);
        .el-icon-plus {
          font-size: 16px;
        }
        .upload-tips {
          font-size: 12px;
        }
      }

      .upload_img {
        width: 120px;
        height: 120px;
        display: block;
      }
    }
    .short,
    .el-select,
    .el-date-editor {
      width: 85%;
    }
    .el-cascader {
      width: 100%;
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #edeef0;
    }
    .el-radio {
      .el-radio__input.is-checked .el-radio__inner {
        border-color: #1966ff;
        background: #1966ff;
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: inherit;
      }
    }
  }
}
</style>